import { LoadingSpinner } from '@kerfjs/ui/loading-spinner';
import { Row } from '@kerfjs/ui/row';
import { Text } from '@kerfjs/ui/text';
import { type SafeHtml } from 'kerfjs';

/**
 * A spinner with a visible label beside it (HS2-07T3SF): the label is vertically
 * centred against the ring with an 8px gap. Prefer this over an ad-hoc
 * spinner + text so labelled progress reads consistently across the app. Use the
 * bare `LoadingSpinner` when there is no visible label.
 */
export function LabeledSpinner({
  label,
  quiet = false,
}: {
  label: string;
  /** Render the label as quiet, compact secondary text. */
  quiet?: boolean;
}): SafeHtml {
  return (
    <Row className="labeled-spinner" vAlign="middle" gap="xs">
      <LoadingSpinner label={label} />
      {quiet ? (
        <Text variant="span" tone="quiet" size="compact">
          {label}
        </Text>
      ) : (
        <span>{label}</span>
      )}
    </Row>
  );
}
